var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBearCondor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.276 44V44.5H61.776H37.983H37.6523L37.5229 44.1957L33.6965 35.1996L33.6948 35.1957L27.9483 22H22.2727L17.2431 35.1783L17.1203 35.5H16.776H12.5142H11.7773L12.0496 34.8152L18.8114 17.8152L18.9367 17.5H19.276H31.276H31.6082L31.7369 17.8063L38.8801 34.8032L38.8814 34.8063L41.1058 40H61.776H62.276V40.5V44Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2756 44V44.5H61.7756H37.9826H37.6519L37.5225 44.1957L33.6944 35.1957L33.3984 34.5H34.1545H38.4201H38.7499L38.8797 34.8032L41.1054 40H61.7756H62.2756V40.5V44Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9476 44.5H13.2783L13.4077 44.1957L17.2359 35.1957L17.5318 34.5H16.7758H12.5101H12.1804L12.0505 34.8032L9.82491 40H7.5297H7.09975L7.03535 40.4251L6.50507 43.9251L6.41797 44.5H6.99943H12.9476Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearCondor);
export default __webpack_public_path__ + "static/media/bear_condor.bd75a5d615f69661a2834b6d6b478fda.svg";
export { ForwardRef as ReactComponent };